<template>
  <CModal
    v-if="showModal"
    :show.sync="showModal"
    :no-close-on-backdrop="true"
    :centered="true"
    title="Modal title 2"
    size="lg"
    class="view-log-modal input-container modal-log-btn mobile-log-details"
  >
    <div>
      <div class="doctor-log-list mb-3">
        <p class="mb-0">{{doctor.doctor_id.full_name}}</p>

        <small class="text-muted">{{doctor.doctor_id.highest_qualification.join()}}</small>
      </div>
      <div>
        <table class="table small-table-padding">
          <tbody>
            <tr v-for="(history,index) in doctor.histories" :key="index">
              <td>Status : {{history.current_document_status}}</td>
              <td>{{dateLabel(history)}}</td>
              <td>
                <a
                  class="cursor btn text-uppercase btn-outline-primary btn-block"
                  @click="showModal=false;$emit('showVerifyModal',{doctor:history,fromLog:false, doctorObj: doctor});"
                >View Details</a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <template #header>
      <h6 class="modal-title">View Log</h6>
      <CButtonClose @click="showModal = false" />
    </template>
  </CModal>
</template>
<script>
import formats from "@/formats";
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .isBetween()
  .build();
export default {
  data() {
    return {
      showModal: false,
      verifyDoctorModal: false,
      doctor: {},
      dayJS
    };
  },
  methods: {
    viewModal(doctor) {
      this.doctor = doctor;
      this.showModal = true;
    },
    dateLabel(history) {
      let text = "";
      switch (history.current_document_status) {
        case "PENDING":
          text = `Requested on : ${dayJS(history.document_uploaded_date).format(
            formats.date_time_format
          )}`;
          break;
        case "APPROVED":
          text = `Approved on : ${dayJS(
            history.approved_details.approved_on
          ).format(formats.date_time_format)}`;
          break;
        case "UPDATED":
          text = `Updated on : ${dayJS(history.document_uploaded_date).format(
            formats.date_time_format
          )}`;
          break;
        case "REJECT":
          text = `Rejected on : ${dayJS(
            history.rejected_details.rejected_on
          ).format(formats.date_time_format)}`;
          break;
      }
      return text;
    }
  }
};
</script>